// src/components/WZFormWithPreview.js
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { AuthContext } from "../context/AuthContext";
import { AutoComplete } from "primereact/autocomplete";
import { FloatLabel } from "primereact/floatlabel";
import AddOddzial from "./dictionaries/AddEgz";
import AddMaterial from "./dictionaries/AddMaterial";
import AddOdbiorca from "./dictionaries/AddOdbiorca";
import AddSamochod from "./dictionaries/AddSamochod";
import { SelectButton } from "primereact/selectbutton";
import { Dialog } from "primereact/dialog";
import "../css/WZFormWithPreview.css";

import WZPrintTemplate from "./WZPrintTemplate";
import { useMediaQuery } from "react-responsive";
import { baseURL } from "../utils/api";
// Upewnij się, że obraz jest w odpowiednim katalogu

const WZFormWithPreview = ({ edit, data, handleSave }) => {
  const options = ["WZ", "RW"];
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [isPrzewoznik, setIsPrzewoznik] = useState(false);
  const [docType, setDocType] = useState(options[0]);
  const { user, token } = useContext(AuthContext);
  const [oplacono, setOplacono] = useState(false);
  const [today, setToday] = useState(new Date(new Date().setHours(12, 0, 0))); // format dd.mm.rrrr
  // Stan nagłówka dokumentu – pola pobierane z formularza
  const [wzHeader, setWzHeader] = useState({
    numerWZ: "", // Numer bieżący WZ – nadawany automatycznie
    firma: null, // Firma (dropdown)
    egz: null, // Opcja z dropdown "Egz."
    odbiorca: null, // Kontrahent (dropdown)
    transport: null, // Środek transportu (dropdown)
    przeznaczenie: "", // Przeznaczenie dokumentu (pole tekstowe)
    uwagi: "", // Uwagi (pole tekstowe)
    kwotaNetto: 0,
    kwotaBrutto: 0,
    oplacono: false,
    data: today,
    typDokumentu: docType,
    isPrzewoznik: false,
    przewoznik: null,
  });

  const [manualTransport, setManualTransport] = useState("");
  const [isManualTransport, setIsManualTransport] = useState(false);

  // Opcje dla dropdownów pobierane z backendu
  const [egzOptions, setEgzOptions] = useState([]);
  const [firmyOptions, setFirmyOptions] = useState([]);
  const [kontrahenciOptions, setKontrahenciOptions] = useState([]);
  const [transportOptions, setTransportOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState(transportOptions);
  // Opcje dla materiałów – dropdown dla "Nazwa materiału"
  const [materialOptions, setMaterialOptions] = useState([]);
  const [recznyNumer, setRecznyNumer] = useState(false);
  // Lista pozycji (wierszy) dodawanych do WZ
  const [products, setProducts] = useState([]);
  const [visible, setVisible] = useState(false);
  const [zawartosc, setZawartosc] = useState([]);
  // Stan formularza dodawania nowej pozycji.
  // Pole "nazwaMaterialu" będzie przechowywało obiekt wybrany z dropdowna.
  const [newProduct, setNewProduct] = useState({
    // kodTowaru nie jest edytowalny – zostanie obliczony jako products.length + 1
    nazwaMaterialu: null,
    ilosc: "",
    cena: "",
    wartosc: "",
  });
  // Stan sugestii dla pola Przeznaczenie
  const [suggestions, setSuggestions] = useState([]);

  const fetchPrzeznaczenieSuggestions = async () => {
    try {
      const response = await axios.get(`${baseURL}api/przeznaczenie`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data; // Tablica sugestii (np. ["Budowa", "Remont", ...])
    } catch (error) {
      console.error("Błąd pobierania sugestii przeznaczenie:", error);
      return [];
    }
  };

  // Funkcja wyszukująca sugestie – pobiera zapisane wartości z localStorage
  const handleComplete = async (event) => {
    const suggestionsList = await fetchPrzeznaczenieSuggestions();
    // Filtrujemy sugestie na podstawie wpisanego tekstu (event.query)
    const filtered = suggestionsList.filter((s) =>
      s.toLowerCase().includes(event.query.toLowerCase())
    );
    setSuggestions(filtered.map((s) => s));
  };

  // Uzupełniane automatycznie pola "Wydał" oraz "Data"
  const wydal = user ? `${user.forname} ${user.name}` : "";

  const refreshEgzOptions = () => {
    axios
      .get(`${baseURL}api/egz`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setEgzOptions(response.data.filter((egz) => egz.dostepny));
      })
      .catch((error) => console.error("Błąd pobierania opcji egz:", error));
  };

  const refreshMaterialOptions = () => {
    axios
      .get(`${baseURL}api/materialy`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) =>
        setMaterialOptions(response.data.filter((m) => m.dostepny))
      )
      .catch((error) => console.error("Błąd pobierania materiałów:", error));
  };

  const refreshKontrahenciOptions = () => {
    axios
      .get(`${baseURL}api/kontrahenci`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) =>
        setKontrahenciOptions(response.data.filter((k) => k.dostepny))
      )
      .catch((error) => console.error("Błąd pobierania kontrahentów:", error));
  };

  const refreshFirmyOptions = () => {
    axios
      .get(`${baseURL}api/firmy`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) =>
        setFirmyOptions(response.data.filter((f) => f.dostepny))
      )
      .catch((error) => console.error("Błąd pobierania firm:", error));
  };

  const refreshTransportOptions = () => {
    axios
      .get(
        `${baseURL}api/samochody${
          wzHeader.odbiorca ? `?odbiorcaId=${wzHeader.odbiorca.id}` : ""
        }`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) =>
        setTransportOptions(response.data.filter((t) => t.dostepny))
      )
      .catch((error) =>
        console.error("Błąd pobierania środków transportu:", error)
      );
  };

  const refreshNumerWZ = () => {
    if (!wzHeader.firma || !wzHeader.egz) return;
    // console.log("Pobieranie numeru dla:", wzHeader.firma, wzHeader.egz, wzHeader.typDokumentu);
    axios
      .get(
        `${baseURL}api/wzNumer?firmaId=${wzHeader.firma.id}&egzId=${wzHeader.egz.id}&typDokumentu=${wzHeader.typDokumentu}&data=${wzHeader.data}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        const nextNumber = response.data.wzNumer;

        setWzHeader((prev) => ({ ...prev, numerWZ: nextNumber }));
      })
      .catch((error) => {
        console.error("Błąd pobierania numeru WZ:", error);
      });
  };

  useEffect(() => {
    if (user.kopalnia)
      setWzHeader((prev) => ({
        ...prev,
        egz: egzOptions.find((egz) => egz.id === user.kopalnia),
      }));
  }, [egzOptions]);

  useEffect(() => {
    // Pobierz numer bieżący WZ
    refreshTransportOptions();
    if (!wzHeader.firma && !wzHeader.egz && !wzHeader.typDokumentu) return; //setWzHeader((prev) => ({ ...prev, numerWZ: "" }))
    (wzHeader.firma || wzHeader.egz || wzHeader.typDokumentu) &&
      !edit &&
      refreshNumerWZ();
  }, [
    wzHeader.firma,
    wzHeader.egz,
    wzHeader.odbiorca,
    wzHeader.typDokumentu,
    wzHeader.data,
  ]);

  useEffect(() => {
    // Pobierz opcje dla pola "Firma"
    refreshFirmyOptions();

    // Pobierz opcje dla pola "Egz."
    refreshEgzOptions();

    // Pobierz kontrahentów
    refreshKontrahenciOptions();

    // Pobierz środki transportu
    refreshTransportOptions();

    // Pobierz opcje dla materiałów
    refreshMaterialOptions();

    if (data && edit) {
      const parsedProducts =
        typeof data.products === "string"
          ? JSON.parse(data.products)
          : data.products;
      parsedProducts.map((prod) => {
        if (prod && typeof prod.nazwaMaterialu === "string") {
          try {
            prod.nazwaMaterialu = JSON.parse(prod.nazwaMaterialu);
          } catch (error) {
            console.error("Błąd parsowania nazwaMaterialu:", error);
          }
        }
        return prod;
      });

      console.log({
        ...data,
        numerWZ: data.numerWZ,
        data: new Date(data.dataWystawienia),
        firma: JSON.parse(data.firma),
        egz: JSON.parse(data.egz),
        odbiorca: JSON.parse(data.odbiorca),
        transport: JSON.parse(data.transport),
        przeznaczenie: data.przeznaczenie,
        uwagi: data.uwagi,
        oplacono: data.oplacono,
        kwotaBrutto: data.kwotaBrutto,
        kwotaNetto: data.kwotaNetto,
        products: parsedProducts,
        typDokumentu: data.typDokumentu,
        przewoznik: data.przewoznik,
      });

      const parsedData = {
        ...data,
        numerWZ: data.numerWZ,
        data: new Date(data.dataWystawienia),
        firma: JSON.parse(data.firma),
        egz: JSON.parse(data.egz),
        odbiorca: JSON.parse(data.odbiorca),
        transport: JSON.parse(data.transport),
        przeznaczenie: data.przeznaczenie,
        uwagi: data.uwagi,
        oplacono: data.oplacono,
        kwotaBrutto: data.kwotaBrutto,
        kwotaNetto: data.kwotaNetto,
        products: parsedProducts,
        typDokumentu: data.typDokumentu,
        przewoznik: JSON.parse(data.przewoznik),
      };

      setWzHeader(parsedData);
      setProducts(parsedProducts);
      setOplacono(data.oplacono);
    }
  }, [token]);

  // Obsługa zmiany pola formularza – aktualizuje stan oraz ustawia aktualnie edytowane pole
  const handleHeaderChange = (value, field) => {
    if (field === "transport") {
      if (typeof value === "string") {
        setManualTransport(value);
        setIsManualTransport(true);
        setWzHeader((prev) => ({ ...prev, transport: { nrRej: value } }));
      } else {
        setManualTransport("");
        setIsManualTransport(false);
        setWzHeader((prev) => ({ ...prev, [field]: value }));
      }
    } else {
      setWzHeader((prev) => ({ ...prev, [field]: value }));
    }
  };

  // Funkcja obsługująca zmiany w formularzu dodawania nowej pozycji
  const handleNewProductChange = (e, field) => {
    setNewProduct((prev) => ({ ...prev, [field]: e.value }));
  };

  // Obsługa zmiany w dropdownie dla "Nazwa materiału"
  const handleMaterialChange = (e) => {
    setNewProduct((prev) => ({ ...prev, nazwaMaterialu: e.value }));
  };

  // Dodawanie nowej pozycji do listy – automatycznie oblicza kod towaru jako numer kolejny
  const addProduct = () => {
    const productToAdd = {
      kodTowaru: products.length + 1,
      ...newProduct,
    };
    setProducts((prev) => [...prev, productToAdd]);
    // Reset formularza dodawania nowej pozycji
    setNewProduct({
      nazwaMaterialu: null,
      ilosc: "",
      cena: "",
      wartosc: "",
    });
    edit &&
      setWzHeader((prev) => ({
        ...prev,
        products: [...prev.products, productToAdd],
      }));
  };

  // Usuwanie pozycji z listy (opcjonalnie)
  const removeProduct = (rowData) => {
    setProducts((prev) => prev.filter((product) => product !== rowData));
    edit &&
      setWzHeader((prev) => ({
        ...prev,
        products: prev.products.filter((product) => product !== rowData),
      }));
  };

  // Funkcja wysyłająca dane WZ (np. przy zapisie) – przykładowo wypisuje dane w konsoli
  const submitWZ = async () => {
    if (!edit) {
      // If we have a manual transport entry and an odbiorca, save it first
      if (isManualTransport && manualTransport && wzHeader.odbiorca) {
        try {
          const newTransport = {
            nrRej: manualTransport,
            dostepny: true,
            odbiorca: [wzHeader.odbiorca.id],
          };
          const response = await axios.post(
            `${baseURL}api/samochodyAdd`,
            newTransport,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          // Update the transport in wzHeader with the newly created transport
          setWzHeader((prev) => ({ ...prev, transport: response.data }));
        } catch (error) {
          console.error("Błąd zapisywania nowego środka transportu:", error);
        }
      }

      const wzData = {
        numerWZ: wzHeader.numerWZ,
        typDokumentu: docType,
        firma: wzHeader.firma,
        egz: wzHeader.egz,
        odbiorca: wzHeader.odbiorca,
        transport: wzHeader.transport,
        przeznaczenie: wzHeader.przeznaczenie,
        wydal,
        userID: user.id,
        products,
        data: wzHeader.data,
        uwagi: wzHeader.uwagi,
        oplacono: wzHeader.oplacono,
        kwotaNetto: wzHeader.kwotaNetto,
        kwotaBrutto: wzHeader.kwotaBrutto,
        isPrzewoznik: wzHeader.isPrzewoznik,
        przewoznik: wzHeader.przewoznik,
      };

      try {
        const response = await axios.post(`${baseURL}api/wz`, wzData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProducts([]);
        setWzHeader({
          numerWZ: "",
          typDokumentu: docType,
          firma: null,
          egz: null,
          odbiorca: null,
          transport: null,
          przeznaczenie: "",
          uwagi: "",
          kwotaNetto: 0,
          kwotaBrutto: 0,
          oplacono: false,
          data: today,
          isPrzewoznik: false,
          przewoznik: null,
        });
        setNewProduct({
          nazwaMaterialu: null,
          ilosc: "",
          cena: "",
          wartosc: "",
        });
        setManualTransport("");
        setIsManualTransport(false);
      } catch (error) {
        console.error("Błąd zapisu WZ:", error);
      }
      refreshEgzOptions();
    } else {
      try {
        console.log("Aktualizacja WZ:", wzHeader);
        const response = await axios.put(
          `${baseURL}api/wz/${wzHeader.id}`,
          wzHeader,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        handleSave(response.data.id);
      } catch (error) {
        console.error(
          "Błąd aktualizacji dokumentu:",
          error.response?.data || error.message
        );
      }
    }
  };

  const printPreview = () => {
    const printableNode = document.getElementById("printableContainerWZTemplate");
    if (!printableNode) return;

    const styleLinks = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
      .map(link => `<link rel="stylesheet" href="${link.href}">`)
      .join('\n');
    const styleTags = Array.from(document.querySelectorAll('style'))
      .map(style => style.outerHTML)
      .join('\n');

    const w = window.open('', '_blank');
    if (!w) return;
    w.document.write(`<!DOCTYPE html>
<html><head>
  <meta charset="utf-8">
  ${styleLinks}
  ${styleTags}
</head><body style="margin:0;padding:0;background:#fff;">
  ${printableNode.innerHTML}
</body></html>`);
    w.document.close();
    w.focus();

    const allLinks = Array.from(w.document.querySelectorAll('link[rel="stylesheet"]'));
    if (allLinks.length === 0) {
      w.print();
    } else {
      let pending = allLinks.length;
      const tryPrint = () => { pending--; if (pending <= 0) w.print(); };
      allLinks.forEach((link) => {
        link.addEventListener('load', tryPrint);
        link.addEventListener('error', tryPrint);
      });
    }
  };

  const submitAndPrintWZ = () => {
    printPreview();
    submitWZ();
  };

  const printPreviewOld = () => {
    const printableNode = document.getElementById("printableContainerWZOld");
    if (!printableNode) return;

    const w = window.open('', '_blank');
    if (!w) return;
    w.document.write(`<!DOCTYPE html>
<html><head>
  <meta charset="utf-8">
  <style>
    * { box-sizing: border-box; }
    body { margin: 0; padding: 0; background: #fff; }
    @page { size: A4 portrait; margin: 5mm; }
    .document-container { page-break-after: always; }
    .copies-container {
      display: flex;
      flex-direction: column;
      height: 287mm;
      width: 200mm;
      justify-content: space-between;
    }
    .printable-wrapper { height: 90mm; margin: 0; box-sizing: border-box; }
    .wz-podglad {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      border: 1px solid #000;
      width: 100%;
      height: 100%;
      font-size: 10pt;
      table-layout: fixed;
    }
    .wz-podglad td {
      text-align: center;
      padding: 1px;
      height: 1.0em;
      overflow: hidden;
    }
    .adaptive-text { position: relative; }
    .adaptive-text b, .adaptive-text p {
      display: inline-block;
      max-width: 100%;
    }
    .przeznaczenie-cell {
      word-break: break-word;
      white-space: normal !important;
      height: auto;
    }
    .wz-podglad-firma {
      padding: 4px;
      height: 8em;
      white-space: normal;
    }
    .wz-pozycja { height: 1.0em; }
    .wz-podglad-naglowki {
      border: 1px solid #000;
      text-align: center;
      background-color: #dddddd;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      font-size: 8.5pt;
      font-weight: normal;
    }
    p { margin: 0; padding: 0; }
  </style>
</head><body>
  ${printableNode.innerHTML}
</body></html>`);
    w.document.close();
    w.focus();
    w.print();
  };

  const submitAndPrintWZOld = () => {
    printPreviewOld();
    submitWZ();
  };

  const tableHeader = (
    <div className="p-fluid tableHeader">
      <div className="p-field">
        <FloatLabel>
          <label>Kod</label>
          <InputText
            value={products.length + 1}
            readOnly
            className="wz-input"
            style={{
              maxWidth: "50px",
            }}
          />
        </FloatLabel>
      </div>

      <div className="p-field">
        <div className="wz-form-add-field">
          <Button
            icon="pi pi-plus"
            className="p-button-secondary p-button-sm"
            text
            tooltip="Dodaj nowy materiał"
            onClick={() => (
              setVisible(true),
              setZawartosc(
                <AddMaterial onAddSuccess={refreshMaterialOptions} />
              )
            )}
          />
          <FloatLabel>
            <label>Materiał</label>
            <Dropdown
              value={newProduct.nazwaMaterialu}
              options={materialOptions}
              onChange={handleMaterialChange}
              optionLabel="nazwa"
              className="wz-dropdownPozycja"
            />
          </FloatLabel>
        </div>
      </div>
      <div className="p-field">
        <FloatLabel>
          <label>Ilość</label>
          <InputNumber
            value={newProduct.ilosc}
            onChange={(e) => handleNewProductChange(e, "ilosc")}
            suffix={" t"}
            style={{
              maxWidth: "80px",
            }}
          />
        </FloatLabel>
      </div>
      <div
        className="p-field "
        style={{ display: "flex", alignItems: "flex-end" }}
      >
        <Button
          label={!isMobile ? "Dodaj" : null}
          icon="pi pi-plus"
          onClick={addProduct}
          disabled={!newProduct.nazwaMaterialu || !newProduct.ilosc}
        />
      </div>
    </div>
  );

  const renderPrintableContent = () => (
    <table
      className="wz-podglad"
      border="1"
      style={{
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        fontSize: "0.8em",
      }}
    >
      <tbody>
        <tr
          style={{
            border: 0,
            padding: 0,
          }}
        >
          <td
            style={{
              width: "10%",
              fontSize: 0,
              margin: 0,
              height: 0,
              padding: 0,
              borderTop: 0,
              overflow: "hidden",
              lineHeight: 0,
            }}
          ></td>
          <td
            style={{
              width: "20%",
              fontSize: 0,
              margin: 0,
              height: 0,
              padding: 0,
              borderTop: 0,
              overflow: "hidden",
              lineHeight: 0,
            }}
          ></td>
          <td
            style={{
              width: "2%",
              fontSize: 0,
              margin: 0,
              height: 0,
              padding: 0,
              borderTop: 0,
              overflow: "hidden",
              lineHeight: 0,
            }}
          ></td>
          <td
            style={{
              width: "2%",
              fontSize: 0,
              margin: 0,
              height: 0,
              padding: 0,
              borderTop: 0,
              overflow: "hidden",
              lineHeight: 0,
            }}
          ></td>
          <td
            style={{
              fontSize: 0,
              margin: 0,
              height: 0,
              padding: 0,
              borderTop: 0,
              overflow: "hidden",
              lineHeight: 0,
            }}
          ></td>
          <td
            style={{
              fontSize: 0,
              margin: 0,
              height: 0,
              padding: 0,
              borderTop: 0,
              overflow: "hidden",
              lineHeight: 0,
            }}
          ></td>
          <td
            style={{
              fontSize: 0,
              margin: 0,
              height: 0,
              padding: 0,
              borderTop: 0,
              overflow: "hidden",
              lineHeight: 0,
            }}
          ></td>
          <td
            style={{
              width: "10%",
              fontSize: 0,
              margin: 0,
              height: 0,
              padding: 0,
              borderTop: 0,
              overflow: "hidden",
              lineHeight: 0,
            }}
          ></td>
          <td
            style={{
              fontSize: 0,
              margin: 0,
              height: 0,
              padding: 0,
              borderTop: 0,
              overflow: "hidden",
              lineHeight: 0,
            }}
          ></td>
          <td
            style={{
              fontSize: 0,
              margin: 0,
              height: 0,
              padding: 0,
              borderTop: 0,
              overflow: "hidden",
              lineHeight: 0,
            }}
          ></td>
          <td
            style={{
              fontSize: 0,
              margin: 0,
              height: 0,
              padding: 0,
              borderTop: 0,
              overflow: "hidden",
              lineHeight: 0,
            }}
          ></td>
          <td
            style={{
              fontSize: 0,
              margin: 0,
              height: 0,
              padding: 0,
              borderTop: 0,
              overflow: "hidden",
              lineHeight: 0,
            }}
          ></td>
        </tr>
        <tr>
          <td colSpan="2" rowSpan="5" className="wz-podglad-firma">
            {wzHeader.firma ? (
              <div
                className="firma-opis"
                style={{
                  fontSize: "0.9em",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <b>{wzHeader.firma.nazwa}</b>
                {wzHeader.firma.kodpocztowy} {wzHeader.firma.miasto}{" "}
                {wzHeader.firma.ulica} {wzHeader.firma.numer}
                <br />
                NIP: {wzHeader.firma.nip} REGON: {wzHeader.firma.regon}
              </div>
            ) : (
              ""
            )}
          </td>
          <td colSpan="5" className="wz-podglad-naglowki">
            Odbiorca
          </td>
          <td colSpan="1" rowSpan="5" style={{ width: "10%" }}>
            <b style={{ fontSize: "1.3em" }}>
              {docType === "WZ" ? `WZ` : "RW"}
            </b>
            <br />
            {docType === "WZ" ? `wydanie materiałów` : "pobranie materiałów"}
            <br />
            {docType === "WZ" ? `na zewn.` : "wewn."}
          </td>
          <td colSpan="2" className="wz-podglad-naglowki">
            Nr bieżący {docType === "WZ" ? `WZ` : "RW"}
          </td>
          <td colSpan="2" className="wz-podglad-naglowki">
            Egz.
          </td>
        </tr>
        <tr style={{ height: "45px" }}>
          <td colSpan="5" rowSpan="3" className="adaptive-text">
            <b>{wzHeader.odbiorca ? wzHeader.odbiorca.nazwa : ""}</b>
          </td>
          <td colSpan="2" rowSpan="3">
            <b>{wzHeader.numerWZ}</b>
          </td>
          <td colSpan="2" rowSpan="3">
            <b>{wzHeader.egz ? wzHeader.egz.skrot : ""}</b>
          </td>
        </tr>
        <tr></tr>
        <tr></tr>
        <tr>
          <td colSpan="5" className="wz-podglad-naglowki">
            Przeznaczenie
          </td>
          <td colSpan="4" className="wz-podglad-naglowki">
            Nr i data faktury - specyfikacji
          </td>
        </tr>
        <tr>
          <td colSpan="2" className="wz-podglad-naglowki">
            Środek transportu
          </td>
          <td
            colSpan="5"
            rowSpan="2"
            className="adaptive-text przeznaczenie-cell"
          >
            <b>{wzHeader.przeznaczenie}</b>
          </td>
          <td colSpan="1" className="wz-podglad-naglowki">
            Wysyłka na koszt
          </td>
          <td colSpan="4" rowSpan="2"></td>
        </tr>
        <tr>
          <td colSpan="2" className="adaptive-text">
            <b>{wzHeader.transport ? wzHeader.transport.nrRej : ""}</b>
          </td>
          <td></td>
        </tr>
        <tr>
          <td
            rowSpan="2"
            className="wz-podglad-naglowki"
            style={{ width: "10%" }}
          >
            Kod towaru - materiału
          </td>
          <td colSpan="5" rowSpan="2" className="wz-podglad-naglowki">
            Nazwa materiału
          </td>
          <td colSpan="2" className="wz-podglad-naglowki">
            Ilość
          </td>
          <td colSpan="2" className="wz-podglad-naglowki">
            Cena
          </td>
          <td colSpan="2" className="wz-podglad-naglowki">
            Wartość
          </td>
        </tr>
        <tr>
          <td className="wz-podglad-naglowki">Wydana</td>
          <td className="wz-podglad-naglowki">Jedn.</td>
          <td className="wz-podglad-naglowki">zł</td>
          <td className="wz-podglad-naglowki">gr</td>
          <td className="wz-podglad-naglowki">zł</td>
          <td className="wz-podglad-naglowki">gr</td>
        </tr>
        {Array.from({ length: 7 }).map((_, i) => {
          const product = products ? products[i] : null;
          return (
            <tr key={i} className="wz-pozycja">
              <td className="adaptive-text" style={{ width: "10%" }}>
                <b>{product ? product.kodTowaru : ""}</b>
              </td>
              <td colSpan="5" className="adaptive-text">
                <b>
                  {product && product.nazwaMaterialu
                    ? typeof product.nazwaMaterialu === "string"
                      ? JSON.parse(product.nazwaMaterialu).nazwa
                      : product.nazwaMaterialu.nazwa
                    : ""}
                </b>
              </td>
              <td>
                <b>{product ? product.ilosc : ""}</b>
              </td>
              <td>
                <b>{product ? "t" : ""}</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          );
        })}
        <tr style={{ width: "100%" }}>
          <td colSpan="4" className="wz-podglad-naglowki wz-podglad-last">
            Wydał
          </td>
          <td colSpan="4" className="wz-podglad-naglowki wz-podglad-last">
            Data
          </td>
          <td colSpan="4" className="wz-podglad-naglowki wz-podglad-last">
            Odebrał
          </td>
        </tr>
        <tr style={{ height: "40px" }}>
          <td
            colSpan="4"
            rowSpan="2"
            className="adaptive-text wz-podglad-last2"
          >
            <b>{wydal}</b>
          </td>
          <td
            colSpan="4"
            rowSpan="2"
            className="adaptive-text wz-podglad-last2"
          >
            <b>{wzHeader.data.toLocaleDateString("pl-PL")}</b>
          </td>
          <td
            colSpan="4"
            rowSpan="2"
            className="adaptive-text wz-podglad-last2"
          ></td>
        </tr>
      </tbody>
    </table>
  );

  const transportInput = (
    <div className="p-field wz-form-field">
      <label>Środek transportu</label>
      <div className="wz-form-add-field">
        <Button
          icon="pi pi-plus"
          className="p-button-secondary p-button-sm"
          text
          tooltip="Dodaj nowy środek transportu"
          onClick={() => (
            setVisible(true),
            setZawartosc(<AddSamochod onAddSuccess={refreshTransportOptions} />)
          )}
        />
        <AutoComplete
          className="wz-input"
          inputStyle={{ width: "100%" }}
          value={
            isManualTransport
              ? manualTransport
              : wzHeader.transport
              ? wzHeader.transport.nrRej
              : ""
          }
          suggestions={filteredOptions.map((t) => t.nrRej)}
          completeMethod={(e) => {
            if (!e.query) {
              // Jeśli pole puste — pokaż wszystko
              setFilteredOptions(transportOptions);
            } else {
              // Filtrowanie po wpisanym ciągu
              const filtered = transportOptions.filter((t) =>
                t.nrRej.toLowerCase().includes(e.query.toLowerCase())
              );
              setFilteredOptions(filtered);
            }
          }}
          onChange={(e) => handleHeaderChange(e.value, "transport")}
          onSelect={(e) => {
            const selected = transportOptions.find((t) => t.nrRej === e.value);
            handleHeaderChange(selected, "transport");
          }}
          placeholder="Wpisz lub wybierz samochód"
        />
      </div>
    </div>
  );

  return (
    <div className="wz-container">
      <div className="wz-main-row">
      {/* Formularz */}
      <div className="form-container">
        <div
          className="naglowek"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          {!edit && (
            <h2 className="naglowek-nowy-dokument">Nowy dokument {docType}</h2>
          )}
          <div
            className="p-field wz-form-field save-buttons"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              label={`Zapisz`}
              icon="pi pi-save"
              onClick={submitWZ}
              className="p-button-success m-2 button-save"
              disabled={
                !wzHeader.firma ||
                !wzHeader.odbiorca ||
                !products.length ||
                !wzHeader.transport?.nrRej
              }
            />
            {!edit && (
              <Button
                label={`Zapisz i drukuj`}
                icon="pi pi-print"
                onClick={submitAndPrintWZ}
                className="p-button-success m-2 button-save"
                disabled={
                  !wzHeader.firma ||
                  !wzHeader.odbiorca ||
                  !products.length ||
                  !wzHeader.transport?.nrRej
                }
              />
            )}
            {!edit && (
              <Button
                label={`Zapisz i drukuj (stare)`}
                icon="pi pi-print"
                onClick={submitAndPrintWZOld}
                className="p-button-secondary m-2 button-save"
                disabled={
                  !wzHeader.firma ||
                  !wzHeader.odbiorca ||
                  !products.length ||
                  !wzHeader.transport?.nrRej
                }
              />
            )}
          </div>
        </div>
        {!edit && (
          <div className="form-doctype-bar">
            <SelectButton
              allowEmpty={false}
              value={docType}
              onChange={(e) => (
                setDocType(e.value), handleHeaderChange(e.value, "typDokumentu")
              )}
              options={options}
            />
          </div>
        )}
        <div className="form-section">
          <div className="form-section-title">Dane dokumentu</div>
          <div className="p-field wz-form-field">
          <label>Numer bieżący {docType}</label>
          <div className="wz-form-add-field">
            {user.role === "Administrator" && (
              <Checkbox
                checked={recznyNumer}
                onChange={(e) => setRecznyNumer(e.checked)}
                style={{ margin: "5px" }}
                tooltip="Wprowadź ręcznie numer i datę"
              />
            )}
            <InputText
              value={wzHeader.numerWZ}
              onChange={(e) =>
                setWzHeader((prev) => ({ ...prev, numerWZ: e.target.value }))
              }
              readOnly={recznyNumer ? false : true}
              className="wz-input"
            />
          </div>
        </div>
        <div className="p-field wz-form-field">
          <label>Firma</label>
          <Dropdown
            value={wzHeader.firma}
            options={firmyOptions}
            onChange={(e) => handleHeaderChange(e.value, "firma")}
            optionLabel="nazwa"
            dataKey="id"
            placeholder="Wybierz firmę"
            className="wz-dropdown"
            filter
            showClear
          />
        </div>
        <div className="p-field wz-form-field">
          <label>Egz.</label>
          <div className="wz-form-add-field">
            <Button
              icon="pi pi-plus"
              className="p-button-secondary p-button-sm"
              text
              tooltip="Dodaj nowy oddział"
              onClick={() => (
                setVisible(true),
                setZawartosc(<AddOddzial onAddSuccess={refreshEgzOptions} />)
              )}
            />
            <Dropdown
              value={
                user.kopalnia
                  ? egzOptions.find((egz) => egz.id === user.kopalnia)
                  : wzHeader.egz
              }
              disabled={user.role === "User"}
              options={egzOptions}
              onChange={(e) => handleHeaderChange(e.value, "egz")}
              optionLabel="adres"
              dataKey="id"
              placeholder="Wybierz egz."
              className="wz-dropdown"
              filter
              showClear
            />
          </div>
        </div>
        </div>

        <div className="form-section">
          <div className="form-section-title">Kontrahent i transport</div>
          <div className="p-field wz-form-field">
          <label>Odbiorca</label>
          <div className="wz-form-add-field">
            <Button
              icon="pi pi-plus"
              className="p-button-secondary p-button-sm"
              text
              tooltip="Dodaj nowego odbiorcę"
              onClick={() => (
                setVisible(true),
                setZawartosc(
                  <AddOdbiorca onAddSuccess={refreshKontrahenciOptions} />
                )
              )}
            />
            <Dropdown
              value={wzHeader.odbiorca}
              options={kontrahenciOptions.sort((a, b) =>
                a.nazwa.localeCompare(b.nazwa)
              )}
              onChange={(e) => handleHeaderChange(e.value, "odbiorca")}
              optionLabel="nazwa"
              dataKey="id"
              placeholder="Wybierz odbiorcę"
              className="wz-dropdown"
              filter
              showClear
            />
          </div>
        </div>
        {transportInput}
        <div className="p-field wz-form-field">
          <label htmlFor="przewoznik" className="p-checkbox-label">
            Przewoźnik
          </label>
          <Checkbox
            inputId="przewoznik"
            onChange={(e) => (
              handleHeaderChange(e.checked, "isPrzewoznik"),
              setIsPrzewoznik(e.checked)
            )}
            checked={wzHeader.isPrzewoznik}
          />
        </div>
        {wzHeader.isPrzewoznik && (
          <>
            <div className="p-field wz-form-field">
              <label>Nazwa przewoźnika</label>
              {/* <Button
                  icon="pi pi-plus"
                  className="p-button-secondary p-button-sm"
                  text
                  tooltip="Dodaj nowego przewoźnika"
                  onClick={() => (
                    setVisible(true),
                    setZawartosc(
                      <AddPrzewoznik onAddSuccess={refreshPrzewoznikOptions} />
                    )
                  )}
                /> */}
              <Dropdown
                value={wzHeader.przewoznik}
                options={kontrahenciOptions.sort((a, b) =>
                  a.nazwa.localeCompare(b.nazwa)
                )}
                onChange={(e) => handleHeaderChange(e.value, "przewoznik")}
                optionLabel="nazwa"
                dataKey="id"
                placeholder="Wybierz przewoźnika"
                className="wz-dropdown"
                filter
                showClear
              />
            </div>
          </>
        )}
        </div>

        <div className="form-section">
          <div className="form-section-title">Szczegóły</div>
          <div className="p-field wz-form-field">
          <label>Przeznaczenie</label>
          <AutoComplete
            value={wzHeader.przeznaczenie}
            suggestions={suggestions}
            completeMethod={handleComplete}
            onChange={(e) => handleHeaderChange(e.value, "przeznaczenie")}
            className="wz-input"
            inputStyle={{ width: "100%" }}
            placeholder="Wpisz przeznaczenie"
          />
        </div>

        <div className="p-field wz-form-field">
          <label>Wydał</label>
          <InputText value={wydal} readOnly className="wz-input" />
        </div>

        <div className="p-field wz-form-field">
          <label>Data</label>
          <Calendar
            value={wzHeader.data}
            dateFormat="dd.mm.yy"
            disabled={recznyNumer ? false : true}
            onChange={(e) => (
              handleHeaderChange(e.value, "data"), setToday(e.value)
            )}
            className="wz-input"
          />
        </div>
        <div className="p-field wz-form-field">
          <label>Uwagi</label>
          <InputTextarea
            rows={1}
            cols={35}
            autoResize
            value={wzHeader.uwagi}
            placeholder="Uwagi"
            onChange={(e) => handleHeaderChange(e.target.value, "uwagi")}
            className="wz-input"
          />
        </div>
        <div className="p-field wz-form-field">
          <label htmlFor="oplacono" className="p-checkbox-label">
            Opłacono
          </label>
          <Checkbox
            inputId="oplacono"
            onChange={(e) => (
              handleHeaderChange(e.checked, "oplacono"), setOplacono(e.checked)
            )}
            checked={wzHeader.oplacono}
          />
        </div>
        {oplacono && (
          <>
            <div className="p-field wz-form-field">
              <label>Kwota brutto</label>
              <InputNumber
                value={wzHeader.kwotaBrutto}
                onChange={(e) => handleHeaderChange(e.value, "kwotaBrutto")}
                suffix={" zł"}
              />
            </div>
            <div className="p-field wz-form-field">
              <label>Kwota netto</label>
              <InputNumber
                value={wzHeader.kwotaNetto}
                onChange={(e) => handleHeaderChange(e.value, "kwotaNetto")}
                suffix={" zł"}
              />
            </div>
          </>
        )}
        </div>
      </div>
      {isMobile && (
        <div style={{ textAlign: "center", marginTop: "1rem" }}>
          <i>
            W celu uzyskania lepszej widoczności danych, skorzystaj z orientacji
            poziomej
          </i>
        </div>
      )}
      {/* Prawa kolumna: podgląd WZ + tabela pozycji */}
      <div className="wz-right-col">
        {/* Podgląd WZ – tylko ORYGINAŁ na ekranie */}
        <WZPrintTemplate
          data={{
            numerWZ: wzHeader.numerWZ,
            typDokumentu: docType,
            egz: wzHeader.egz,
            firma: wzHeader.firma,
            odbiorca: wzHeader.odbiorca,
            przeznaczenie: wzHeader.przeznaczenie,
            dataWystawienia: wzHeader.data,
            transport: wzHeader.transport,
            wydal: wydal,
            products: products,
          }}
          copyLabels={["ORYGINAŁ"]}
        />
        <div className="form-products-section">
          <h2>Pozycje dokumentu</h2>
          <DataTable
            value={products}
            paginator
            rows={5}
            header={tableHeader}
            emptyMessage="Brak pozycji"
          >
            <Column
              header="Kod towaru"
              field="kodTowaru"
              style={{
                maxWidth: "50px",
              }}
            />
            <Column
              header="Nazwa materiału"
              body={(rowData) =>
                rowData.nazwaMaterialu
                  ? typeof rowData.nazwaMaterialu === "string"
                    ? JSON.parse(rowData.nazwaMaterialu).nazwa
                    : rowData.nazwaMaterialu.nazwa
                  : ""
              }
            />
            <Column
              header="Ilość - wydana i jednostka"
              field="ilosc"
              style={{
                maxWidth: "80px",
              }}
              body={(rowData) => <span>{rowData.ilosc} t</span>}
            />
            <Column
              header="Akcja"
              body={(rowData) => (
                <Button
                  icon="pi pi-trash"
                  className="p-button-danger p-button-sm"
                  onClick={() => removeProduct(rowData)}
                />
              )}
            />
          </DataTable>
        </div>
      </div>
      </div>
      <Dialog
        visible={visible}
        onHide={() => setVisible(false)}
        style={{ width: "70vw" }}
      >
        {zawartosc}
      </Dialog>
      <div id="printableContainerWZTemplate" className="printable-hidden">
        <WZPrintTemplate
          data={{
            numerWZ: wzHeader.numerWZ,
            typDokumentu: docType,
            egz: wzHeader.egz,
            firma: wzHeader.firma,
            odbiorca: wzHeader.odbiorca,
            przeznaczenie: wzHeader.przeznaczenie,
            dataWystawienia: wzHeader.data,
            transport: wzHeader.transport,
            wydal: wydal,
            products: products,
          }}
          copyLabels={["ORYGINAŁ", "KOPIA", "KOPIA"]}
          className="wz-copies-print"
        />
      </div>
      <div id="printableContainerWZOld" className="printable-hidden">
        <div className="document-container">
          <div className="copies-container">
            {Array.from({ length: 3 }).map((_, idx) => (
              <div key={idx} className="printable-wrapper">
                {renderPrintableContent()}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WZFormWithPreview;
